const categories = [
  { value: 'English', label: 'en' },
  { value: 'Spanish (coming soon)', label: 'es' },
  { value: 'French (coming soon)', label: 'fr' },
  { value: 'Japanese (coming soon)', label: 'ja' },
  { value: 'Russian (coming soon)', label: 'ru' },
  { value: 'German (coming soon)', label: 'de' },
  { value: 'Italian (coming soon)', label: 'it' },
  { value: 'Korean (coming soon)', label: 'ko' },
  { value: 'Portuguese (coming soon)', label: 'pt-BR' },
  { value: 'Turkish (coming soon)', label: 'tr' },
];

export default categories;
